// Fullscreen + landscape lock for touch devices (Android Chrome and similar).
// Browsers only allow fullscreen in response to a user gesture such as a tap.

// Phones and tablets; touchscreen laptops report a fine (mouse) primary pointer
export function isTouchDevice() {
    return window.matchMedia('(pointer: coarse)').matches;
}

export function isFullscreen() {
    return !!(document.fullscreenElement || document.webkitFullscreenElement);
}

export function fullscreenSupported() {
    const el = document.documentElement;
    return !!(el.requestFullscreen || el.webkitRequestFullscreen);
}

export async function enterFullscreen() {
    const el = document.documentElement;
    try {
        if (el.requestFullscreen) {
            await el.requestFullscreen({ navigationUI: 'hide' });
        } else if (el.webkitRequestFullscreen) {
            el.webkitRequestFullscreen();
        }
    } catch (err) {
        console.warn('Fullscreen request was refused', err);
        return;
    }
    // Orientation can only be locked while fullscreen, and not every browser allows it
    try {
        if (window.screen.orientation && window.screen.orientation.lock) {
            await window.screen.orientation.lock('landscape');
        }
    } catch (err) {
        console.warn('Could not lock orientation', err);
    }
}
